export const otaConnectWizard = {
  google: {
    lead: "Primero comprobamos que la ficha de tu alojamiento esté completa: Google no tiene panel propio y solo enseña lo que le mandemos.",
    goConnect: "Continuar en Channex",
    nextIsChannex: "El último paso —elegir qué habitaciones y tarifas ve Google— se hace en la pantalla de Channex, que se abrirá a continuación.",
    typeLabel: "¿Qué tipo de alojamiento es?",
    hotel: "Hotel",
    hotelHint: "Con varias habitaciones",
    vr: "Alojamiento vacacional",
    vrHint: "Una casa o apartamento entero",
    checking: "Revisando la ficha del alojamiento…",
    ready: "Todo listo: Google puede publicarlo.",
    missing: "Falta 1 cosa antes de conectar | Faltan {count} cosas antes de conectar",
    canFix: "Parte de eso ya lo tenemos guardado y podemos subirlo nosotros.",
    prepare: "Preparar la ficha",
    prepareFailed: "No se pudo preparar la ficha.",
    checkFailed: "No se pudo revisar la ficha.",
    cancelLabel: "Política de cancelación",
    cancelFree: "Cancelación gratuita",
    cancelNon: "No reembolsable",
    bedrooms: "Dormitorios",
    beds: "Camas",
    bathrooms: "Baños",
  },
  common: {
    close: "Cerrar",
  },
  intro: {
    imageAlt: "Antes de conectar Booking, ten esto en cuenta",
    continue: "Entendido, continuar",
  },
  header: {
    edit: "Editar",
    connect: "Conectar",
    guidedStep: "Asistente guiado · paso {current} de {total}",
  },
  steps: {
    connection: "Conexión",
    rooms: "Habitaciones",
    rates: "Tarifas",
    review: "Revisión",
    done: "Listo",
  },
  fields: {
    hotel_id: { label: "ID del hotel", hint: "Lo encuentras en tu extranet de la OTA, arriba a la derecha." },
    hotel_code: { label: "Código del hotel", hint: "Identificador de tu propiedad en la OTA." },
    property_id: { label: "ID de la propiedad", hint: "" },
    listing_id: { label: "ID del anuncio", hint: "" },
    property_code: { label: "Código de la propiedad", hint: "" },
    username: { label: "Usuario", hint: "Tu usuario de acceso al extranet de la OTA." },
    user: { label: "Usuario", hint: "Tu usuario de acceso al extranet de la OTA." },
    password: { label: "Contraseña", hint: "Tu contraseña del extranet de la OTA." },
    api_key: { label: "Clave API (API key)", hint: "Te la facilita la OTA." },
    agent_id: { label: "ID de agente", hint: "" },
  },
  step0: {
    lead: "Pega el identificador de tu propiedad en el canal. Lo verificamos al instante.",
    loadingChannel: "Cargando requisitos del canal…",
    notAvailable: "Este canal aún no está disponible por API guiada.",
    oauthText: "{name} se conecta con tu cuenta mediante inicio de sesión seguro. Al pulsar abrimos {name} en otra pestaña para que autorices; al volver, la conexión aparece en tus canales.",
    oauthConnect: "Conectar con {name}",
    oauthOpened: "Abrimos {name} en otra pestaña. Autoriza ahí y la conexión aparecerá en tus canales.",
    currencyLabel: "Moneda",
    currencyTooltip: "La define el canal para tu propiedad. Se completa sola al verificar la conexión; no se edita.",
    currencyPlaceholder: "Se completa al verificar",
    currencyDetected: "Detectada automáticamente",
    currencyVerifyToDetect: "Verifica la conexión para detectarla",
    verified: "Verificado",
    testConnection: "Probar conexión",
    testOk: "Conexión verificada. Continúa para emparejar habitaciones y tarifas.",
    testFailedDefault: "No pudimos verificar la conexión. Revisa el identificador.",
  },
  step1: {
    leadAirbnb: "Empareja cada anuncio de Airbnb con una de tus unidades.",
    leadOther: "Empareja cada habitación de {channel} con una unidad de tu anuncio.",
    listingChip: "Anuncio: {name}",
    noLimitChip: "Sin límite de cuentas ni propiedades",
    loadingRooms: "Cargando habitaciones del canal…",
    noRooms: "No se encontraron habitaciones para mapear.",
    dupUnitWarning: "«{unit}» está puesta en más de una habitación de {channel}. Cada habitación del canal tiene que ir a una habitación distinta tuya: si se guarda así, {channel} las vendería todas al mismo precio. Corrígelo abajo antes de continuar.",
    searchPlaceholder: "Buscar…",
    noRoomMatch: "Ninguna habitación coincide con «{query}».",
    copied: "Copiado",
    copyId: "Copiar ID: {id}",
    rateCountMeta: "{channel} · {count} tarifa(s)",
    edit: "Editar",
    disconnect: "Desconectar",
    unitSearchPlaceholder: "Busca tu unidad o anuncio…",
    noMatch: "Sin coincidencias",
    cancel: "Cancelar",
  },
  step2: {
    lead: "La tarifa principal de cada habitación se rellena sola con tu tarifa de {channel}. Si una habitación tiene varias tarifas, indica qué % de más (o de menos) cobrarás en cada una.",
    crossedFixed: "Una tarifa estaba emparejada con otra habitación, lo que haría que {channel} vendiera al precio equivocado. Se ha vuelto a poner la de cada habitación: revísalas antes de continuar. | {count} tarifas estaban emparejadas con otra habitación, lo que haría que {channel} vendiera al precio equivocado. Se han vuelto a poner la de cada habitación: revísalas antes de continuar.",
    noRates: "No se encontraron tarifas para mapear.",
    yourPct: "Tu % para esta habitación",
    auto: "Automático",
    changePct: "Cambiar %",
    multiRateAlert: "Esta habitación tiene varias tarifas. Indica qué porcentaje de más (o de menos) vas a cobrar a tus huéspedes en cada una si reservan por {channel}.",
    minStayOnApply: "Se guarda al pulsar «Aplicar».",
    minStayMissing: "Sin estancia mínima propia: {channel} la vende con la mínima de la tarifa principal",
    setMinStay: "Poner estancia mínima",
    nights: "{n} noche | {n} noches",
    minNights: "mín. {n} noche | mín. {n} noches",
    minInherited: "mín. de la tarifa principal",
    ownPlanSummary: "precio y mínima propios",
    minStayNotDerived: "No se ha puesto la estancia mínima de {nights}: «{rate}» es una tarifa principal y usa su propia estancia mínima. Para que {channel} pida {nights} en esta tarifa, aplica un % en lugar de elegirla.",
  },
  step3: {
    lead: "Esto es lo que vamos a conectar en {channel}. Revísalo y pulsa Conectar.",
    channelCurrency: "Moneda del canal:",
    chargesNote: "El check-in/out y los cargos (limpieza, etc.) se toman de la configuración de tu propiedad.",
  },
  done: {
    titleConnected: "¡{name} conectado!",
    titleUpdated: "¡{name} actualizado!",
    subActive: "El canal está activo: ya estamos sincronizando precios y disponibilidad.",
    subPaused: "El canal está conectado en pausa. Actívalo para empezar a sincronizar precios y disponibilidad.",
    subUpdated: "El mapeo del canal se actualizó correctamente.",
    notificationSent: "Notificación enviada",
    syncing: "Sincronizando…",
    paused: "En pausa",
    activateTitle: "Activar canal",
    activateDesc: "Empieza a enviar precios y disponibilidad a {channel}.",
    activateBtn: "Activar canal",
    activated: "Activado",
    loadReservationsTitle: "Extraer reservas futuras",
    loadReservationsDesc: "Trae a WACheckin las reservas que ya tengas en {channel}.",
    imported: "Importadas",
    extract: "Extraer",
  },
  rates: {
    mainRate: "Tarifa principal",
    standardRate: "Tarifa Estándar",
  },
  rooms: {
    listingFallback: "Anuncio {id}",
    unitFallback: "unidad",
  },
  buttons: {
    back: "Atrás",
    saveChanges: "Guardar cambios",
    connect: "Conectar",
    finish: "Finalizar",
    continue: "Continuar",
  },
  errors: {
    dupUnit: "La unidad «{unit}» está asignada a más de una habitación de {channel}. Cada habitación debe ir a una unidad distinta.",
    crossedBlocked: "Hay una tarifa emparejada con otra habitación ({list}). Vuelve al paso de tarifas y elige la de cada habitación: si se guardara así, {channel} vendería al precio equivocado. | Hay {count} tarifas emparejadas con otra habitación ({list}). Vuelve al paso de tarifas y elige la de cada habitación: si se guardara así, {channel} vendería al precio equivocado.",
    dupRate: "La tarifa «{rate}» está emparejada con más de una habitación de {channel} ({rooms}). Cada habitación debe llevar su propia tarifa: si se guardara así, se venderían al mismo precio.",
    roomJoiner: " y ",
    dupRateFallback: "una tarifa",
    dupUnitFallback: "esta unidad",
    needRate: "Empareja al menos una tarifa antes de conectar.",
    updateFailed: "No se pudo actualizar la conexión.",
    createFailed: "No se pudo crear la conexión.",
    unmapFailed: "No se pudo desconectar el anuncio.",
    needAirbnbMap: "Empareja al menos un anuncio con una unidad.",
    unitNoChannexRate: "La unidad \"{unit}\" no tiene una tarifa con id en Channex.",
    airbnbSaveFailed: "No se pudieron guardar los mapeos de Airbnb.",
    actionFailed: "No se pudo ejecutar la acción.",
    oauthLinkFailed: "No se pudo generar el enlace de conexión.",
    testFailed: "Error al probar la conexión.",
    testNoVerify: "Este canal no requiere verificación previa.",
    rateCreateFailedNeedStandard: "No se pudo crear la tarifa. Revisa que la unidad tenga una Tarifa Estándar.",
    rateCreateFailed: "No se pudo crear la tarifa.",
    minStaySaveFailed: "Se ha elegido «{rate}», pero no se pudo guardar su estancia mínima de {nights}: sigue con la que tenía.",
  },
};
